import { useState, useEffect } from 'react'
import gql from '../utils/graphql'
import { getUser, createDoctor } from '../graphql/queries'
import { get } from 'lodash'

const useUser = sessionId => {
  const [user, setUser] = useState()

  const reloadUser = () => {
    setUser(null)
  }

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = get(
          await gql({
            operation: getUser,
            path: 'getUser',
            variables: {
              sessionId:
                sessionId ||
                (typeof localStorage !== 'undefined' &&
                  localStorage.getItem('session'))
            }
          }),
          'body'
        )
        const oktaId = get(res, 'oktaId')
        if (oktaId) {
          await gql({
            operation: createDoctor,
            path: 'createDoctor',
            variables: {
              sessionId:
                sessionId ||
                (typeof localStorage !== 'undefined' &&
                  localStorage.getItem('session')),
              oktaId
            }
          })
        }
        setUser(res)
      } catch (e) {
        console.error(e)
      }
    }

    if (sessionId && !user) fetchUser()
  }, [sessionId, user])

  return [user, reloadUser]
}

export default useUser
